/* Progressive layout only: keep the original policy/page nodes and all their text. */
(() => {
  const script = document.currentScript || document.querySelector('script[data-information-layout]');
  const layout = script?.dataset.informationLayout;
  if (!['editorial', 'guide'].includes(layout)) return;
  const policy = document.querySelector('#MainContent .shopify-policy__container');
  const page = document.querySelector('#MainContent .main-page-title')?.parentElement;
  const root = policy || page;
  const copy = policy ? policy.querySelector('.shopify-policy__body .rte') || policy.querySelector('.shopify-policy__body') : page?.querySelector('.rte');
  const title = root?.querySelector('h1');
  if (!root || !copy || !title || root.dataset.informationReady) return;
  const originalText = copy.textContent;
  const headings = [...copy.children].filter(el => el.tagName === 'H2');
  if (!headings.length) return;
  const header = document.createElement('header');
  header.className = 'information-header';
  const headingGroup = document.createElement('div');
  headingGroup.className = 'information-heading';
  headingGroup.append(title); header.append(headingGroup);
  let sourceIntro = null;
  if (script.dataset.informationImage && layout === 'editorial') {
    sourceIntro = document.createElement('div');
    sourceIntro.className = 'information-source-intro';
    while (copy.firstChild && copy.firstChild !== headings[0]) sourceIntro.append(copy.firstChild);
    headingGroup.append(sourceIntro);
  }
  if (script.dataset.informationImage) {
    const image = document.createElement('img');
    image.src = script.dataset.informationImage;
    image.alt = ''; // Existing category image is decoration, not a new business claim.
    image.width = 1600; image.height = 900;
    image.className = 'information-about-image';
    header.append(image);
    root.classList.add('information-page--about');
  }
  const content = document.createDocumentFragment();
  let target = content;
  let index = 0;
  [...copy.childNodes].forEach(node => {
    if (node.nodeType === 1 && node.tagName === 'H2') {
      const section = document.createElement('section');
      section.className = 'information-section';
      if (!node.id) {
        let id = `information-section-${++index}`;
        while (document.getElementById(id)) id += '-item';
        node.id = id;
      }
      section.setAttribute('aria-labelledby', node.id);
      section.append(node);
      target = document.createElement('div');
      target.className = 'information-section-content';
      section.append(target); content.append(section);
    } else target.append(node);
  });
  copy.append(content);
  // Moving nodes must preserve every word, link and original control.
  if ((sourceIntro?.textContent || '') + copy.textContent !== originalText) throw new Error('Information layout altered source text');
  copy.classList.add('information-copy');
  const firstParagraph = copy.querySelector('p');
  if (firstParagraph && /^Last Updated:/i.test(firstParagraph.textContent.trim())) firstParagraph.classList.add('information-updated');
  const frame = document.createElement('div');
  frame.className = 'information-frame';
  const nav = document.createElement('nav');
  nav.className = 'information-navigation'; nav.setAttribute('aria-label', 'On this page');
  const details = document.createElement('details');
  const label = document.createElement('summary'); label.className = 'information-navigation-label'; label.textContent = 'On this page';
  details.append(label);
  const list = document.createElement('ol');
  headings.forEach(heading => {
    const item = document.createElement('li'); const link = document.createElement('a');
    link.href = '#' + heading.id; link.textContent = heading.textContent;
    link.addEventListener('click', () => {
      if (innerWidth < 750) details.open = false;
      list.querySelectorAll('a').forEach(a => a.removeAttribute('aria-current'));
      link.setAttribute('aria-current', 'location');
    });
    item.append(link); list.append(item);
  });
  details.append(list); nav.append(details);
  const media = matchMedia('(min-width: 750px)');
  const expandNavigation = () => { details.open = media.matches; };
  expandNavigation(); media.addEventListener('change', expandNavigation);
  root.prepend(header);
  copy.before(frame); frame.append(nav, copy);
  root.classList.add('information-page', `information-page--${layout}`);
  root.dataset.informationReady = 'true';
})();
